import { render, staticRenderFns } from "./CommonModal.vue?vue&type=template&id=23419af6&scoped=true"
import script from "./CommonModal.vue?vue&type=script&lang=js"
export * from "./CommonModal.vue?vue&type=script&lang=js"
import style0 from "./CommonModal.vue?vue&type=style&index=0&id=23419af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23419af6",
  null
  
)

export default component.exports